import { useMutation, useQueryClient } from '@tanstack/react-query'
import { confirmSignIn } from 'aws-amplify/auth'

import { queries } from 'src/lib/query-keys'
import { sendEvent } from 'src/shared/api/events/send-event'

export const useConsumerSignInComplete = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ challengeResponse, signInResult }: { challengeResponse: string; signInResult: any }) => {
      const result = await confirmSignIn({
        challengeResponse,
      })

      if (result.isSignedIn) {
        // First invalidate auth queries to refresh the auth state
        await queryClient.invalidateQueries({ queryKey: queries.auth._def })

        // Then invalidate user data queries to fetch fresh data
        await queryClient.invalidateQueries({ queryKey: queries.consumers.me.queryKey })

        // Track successful sign in
        const email = signInResult.username
        sendEvent({
          eventType: 'auth_consumer_signin_success',
          info: { email },
        })
      }

      return result
    },
    onError: (error: unknown) => {
      const errorName = error instanceof Error ? error.name : 'unknown'
      const errorMessage = error instanceof Error ? error.message : 'Unknown error'
      console.error('Sign-in complete error:', errorName, errorMessage)

      sendEvent({
        eventType: 'auth_consumer_signin_complete_error',
        info: { error: errorName, message: errorMessage },
      })
    },
  })
}
